import { Box, Link } from '@mui/material';

import { SOCIAL_ICON_ITEMS } from '~/constants/socials';

export default function ListOfLinksPreviewSocials({ socialLinks, sx = {} }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '16px 12px',
        ...sx,
      }}
    >
      {socialLinks.map((item, index) => {
        const icon =
          item.icon ||
          SOCIAL_ICON_ITEMS.find(
            ({ label, network }) =>
              label?.toLowerCase() === item.label?.toLowerCase() ||
              network?.toLowerCase() === item.network?.toLowerCase(),
          )?.icon;

        return (
          <Link key={item.id + index} href={item.url} target="_blank" rel="noopener noreferrer" sx={{ height: '28px' }}>
            <img src={icon} alt={item.label} width={28} height={28} />
          </Link>
        );
      })}
    </Box>
  );
}
